import React from 'react';

const colors = [
    { name: 'Prussian Blue', hex: '#01254B' },
    { name: 'Hunter Green', hex: '#4A664E' },
    { name: 'Dry Sage', hex: '#B3C295' },
    { name: 'Vanilla Custard', hex: '#F3ECB0' },
    { name: 'Cornsilk', hex: '#FAF6DE' },
    { name: 'Pale Sky', hex: '#CAE3F6' },
    { name: 'Alice Blue', hex: '#E5F4FF' },
];

const DressCode: React.FC = () => {
    return (
        <section className="bg-white py-24 md:py-32 px-4">
            <div className="max-w-3xl mx-auto">
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-dry_sage mb-4">
                    дресс-код
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-6">
                    Палитра вечера
                </h2>
                <div className="flex items-center justify-center gap-3 mb-10 divider-ornament-green max-w-xs mx-auto">
                    <span className="text-dry_sage text-xl animate-heart">♥</span>
                </div>
                <p className="font-sans text-base md:text-lg text-prussian_blue/70 leading-relaxed max-w-xl mx-auto mb-14">
                    Мы будем рады, если ваш наряд будет выдержан в любом пастельном, приглушенном, нюдовом тоне,&nbsp;или в одном из оттенков нашей свадебной палитры.
                    Мужчины могут приходить в классических черных костюмах.
                    Это поможет создать гармоничную и&nbsp;красивую атмосферу праздника.
                    Необязательно придерживаться оттенков указаных ниже.
                </p>
                <div className="flex flex-wrap justify-center gap-5 md:gap-6">
                    {colors.map((color) => (
                        <div key={color.hex} className="flex flex-col items-center group">
                            <div
                                className="w-16 h-16 md:w-20 md:h-20 rounded-full golden-border shadow-card
                                           group-hover:scale-110 group-hover:shadow-elegant transition-all duration-500"
                                style={{ backgroundColor: color.hex }}
                            />
                            <span className="font-sans text-[10px] md:text-xs text-prussian_blue/50 mt-3 tracking-wide">
                                {color.name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DressCode;

